export default {
  ActionTeaser: 'actionteaser:[SID]:[ID]',
  Adcash: '[ssp]:[ban]:[zone]',
  AdHub: '{ad_id}:{click_id}:{site_id}',
  Advertlink: '[CID]:[SID]:[TID]',
  BigClick: '{TID}:{SID}:{CID}',
  Bing: '{AdGroupId}:{AdId}:{CampaignId}:{TargetId}',
  BodyClick: 'bodyclick:[SID]:[ID]',
  'Content.ad': '[adid]:[cid]:[did]',
  'Direct/Advert': 'directadvert:%SITE_ID%:%AD_ID%',
  Etarg: 'etarg:site_id:teaser_id',
  ExoClick: '{campaign_id}:{category_id}:{conversions_tracking}:{cost}:{site_id}',
  'Facebook Ads': '{utm_source}:{utm_medium}:{utm_campaign}:{utm_term}:{utm_content}',
  GlobalTeaser: 'globaltizer:{sid}:{tid}',
  Goodsredtram: 'redtram:{GOOD_ID}:{SITE_NAME}',
  'Google Adwords': 'google:{campaignid}:{adgroupid}:{keyword}',
  Kadam: '{click_id}:{site_id}:{ad_id}',
  MediaVenus: '[SID]:[CID]:[TID]',
  MegaTizer: '[CID]:[SID]:[ID]',
  MGID: '{campaign_id}:{geo}:{teaser_id}:{widget_id}:{click_price}',
  MobiAds: '[camp_id]:[ad_id]:[place_id]',
  MyTarget: 'mytarget:campaign_id:banner_id',
  Novostimira: 'novostimira:{nm_g}:{nm_inf_g}',
  Oblivki: 'Oblivki:[TID]:[CID]:[SID]',
  Octobird: 'octobird:{OB_SITE_ID}',
  PropellerAds: '{bannerid}:{campaignid}:{zoneid}',
  Recreativ: '{SiteCategoryID}:{SiteID}:{OfferID}',
  Revcontent: '{boost_id}:{content_id}:{widget_id}:{adv_targets}',
  TeaserMedia: 'catid:domain:tid',
  TeaserNet: 'tizernet:[SITE_ID]:[TEASER_ID]',
  Tovarro: 'tovarro:{teaser_id}:{widget_id}',
  TrafficJunky: '{AdID}:{BanID}:{BidValue}:{CampaignID}:{SpotName}',
  Visitweb: 'visitweb:{SITE}:{AD}',
  vk_public: 'vkpublic:publickXX:postXX',
  'VK Target': '{utm_source}:{utm_medium}:{utm_campaign}',
  'Yandex Direct': 'yandex:{campaign_id}:{creative_id}:{keyword}',
  Yottos: 'yottos:{source}:{content}',
  Zeropark: '{campaign_id}:{campaign_name}:{cid}:{keyword}',
};